import React, { useState } from 'react';
import { getInitials } from '@scramble/utils'
import FallbackIcon from '@scramble/design-system/icons/user-03.svg';
import { AvatarProps } from './types';
import s from './Avatar.module.scss';

export const Avatar = ({ url, size = 32, name }: AvatarProps) => {
  const [imgError, setImgError] = useState(false);

  const style: React.CSSProperties = {
    width: size,
    height: size,
    minWidth: size
  };

  // Rule 1: URL provided and hasn't errored — show image
  if (url && !imgError) {
    return (
      <div className={s.avatar} style={style} data-variant="image">
        <img
          src={url}
          alt={name ?? ''}
          className={s.avatar__img}
          onError={() => setImgError(true)}
        />
      </div>
    );
  }

  // Rule 2: URL errored (or no URL) and name provided — show initials
  if (name) {
    const initials = getInitials(name);
    if (initials) {
      return (
        <div className={s.avatar} style={style} data-variant="initials">
          <span className={s.avatar__initials} aria-label={name}>
            {initials}
          </span>
        </div>
      );
    }
  }

  // Rule 3: No usable image, no name — show icon fallback
  return (
    <div className={s.avatar} style={style} data-variant="fallback">
      <img src={FallbackIcon} alt="user" width={16} height={16} />
    </div>
  );
};